<template>
    <div>
        <div class="row mt-2">
            <div class="col-6">
                <p><i class="fas fa-info-circle"></i> This feature allows companies to be imported from a data file. The system will automatically detect
                    the file's source if the provider has already been implemented. If the provider is not implemented,
                    the system will display an error, and you will need to request implementation from the our IT
                    department.</p>
                <p><i class="fas fa-info-circle"></i> The system will import data from the error free rows. If error is encountered during processing row,
                    then the error will be displayed below and data won't be save.</p>
                <p><i class="fas fa-info-circle"></i> After success import you will see success message and the company list will open in new tab.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <form @submit.prevent="" ref="companyImportForm">
                    <label class="form-label" for="import_file">Select file to upload:</label>
                    <input type="file" id="import_file" name="import_file" class="form-input mt-2">
                    <button v-if="importing" class="btn orcaBtn" :disabled="importing">Importing data, please wait
                        ...</button>
                    <button v-else class="btn orcaBtn" @click="importFile">Import</button>
                </form>
            </div>
        </div>
        <div class="row">
            <div v-if="logs.length > 0" class="col mt-4">
                <div v-for="message in logs">
                    <p>{{ message }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'import_company',
    data() {
        return {
            logs: [],
            importing: false
        }
    },
    methods: {
        importFile() {
            this.importing = true;
            this.logs = [];
            const file = this.$refs.companyImportForm.import_file.files[0];

            if (!file) {
                this.logs.push('No file selected!');
                this.importing = false;
                return;
            }

            this.postData(file);
        },
        postData(file) {
            const formData = new FormData();
            formData.append("file", file);

            axios.post(this.crmApiPath + 'company/import',  formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(response => {
                this.logs = response.data.validation_errors;

                if(this.logs.length === 0) {
                    this.logs.push('Data imported succesfully!');
                    this.$router.push('/companies/all');
                    this.$tabs.refresh('/companies/all', true)
                }

                this.importing = false;
            });
        }
    }
}
</script>